export default {
  state: {
    visibility: false,
    selected_booking: null
  },
  mutations: {
    INIT_BOOKING_DETAIL_DIALOG(state, payload) {
      state.visibility = true
      state.selected_booking = payload
    },
    SET_BOOKING_DETAIL_DIALOG_VISIBILITY(state, payload) {
      state.visibility = payload
      if (!payload) state.selected_booking = null
    }
  }
}
